var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInput',{attrs:{"context":_vm.context}},[_c('PrimeVueInputNumber',_vm._g(_vm._b({ref:"input",on:{"blur":_vm.context.blurHandler},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'PrimeVueInputNumber',_vm.attributes,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }